import { Component, OnInit ,Input} from '@angular/core';

import{ ProductService } from '../../../../../services/product.service'
@Component({
  selector: 'app-listproduct',
  templateUrl: './listproduct.component.html',
  styleUrls: ['./listproduct.component.css']
})
export class ListproductComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;
  ItemProduct;
  constructor(private product:ProductService) { 

  }

  ngOnInit() {
    let getproduct = this.product.getProduct();
    getproduct.subscribe((snapshot) => {
      this.ItemProduct = snapshot
    })
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/product-list/view/listproduct/listproduct.component.ts